import { ReactNode } from 'react';

import { cn } from '../../libs/utils';
import { Search, SearchProps } from '../search';

interface SearchTopNavigationProps extends Omit<SearchProps, 'className'> {
  leftAction?: ReactNode;
  rightAction?: ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export function SearchTopNavigation({ leftAction, rightAction, className, fullWidth = false, ...searchProps }: SearchTopNavigationProps) {
  return (
    <div className={cn('sticky top-0 z-top-navigation flex h-[52px] w-full items-center justify-center', className)}>
      <div
        className={cn('flex w-full items-center justify-between', {
          'container-padding-small': !fullWidth,
          'px-normal-medium': fullWidth
        })}
      >
        {leftAction && <div className="shrink-0">{leftAction}</div>}
        <div className="flex-1 container-padding-small">
          <Search {...searchProps} />
        </div>
        {rightAction && <div className="shrink-0">{rightAction}</div>}
      </div>
    </div>
  );
}
